export const TOTAL_LINK_CARD_STAGES = 5
export const TOTAL_ADD_CARD_STAGES = 10
